import React from 'react';
import './style.scss';
import Button from "../common/button";
import {SUPERUSER_PERMISSION_ID} from "../../constants";
import SendPasswordLink from "../../features/manageUserProfile/sendPasswordLink";

const UserProfile = (props) => {
  const {
    profile,
    gotoEditAction,
    sendResetPasswordAction
  } = props;

  const user = profile.user;

  const userRole = (profile) ? profile.userRoleList.find(element => element.id === parseInt(profile.user.roleId)) : {};
  const program = (profile) ? profile.programList.find(element => element.id === parseInt(profile.user.programId)) : {};

  const superUser = (profile.userPermission.permissionId === SUPERUSER_PERMISSION_ID);

  return (
    <div className="user-profile">
      <div className='user-profile-header'>
        <div className='user-profile-title'>User Info</div>
        <div className='user-profile-buttons'>
          <Button label='Edit' action={gotoEditAction}/>
        </div>
      </div>
      <div className="user-profile-body">
        <div className="user-info">
          <div className="user-info-item">
            <div className="user-info-label">
              Email:
            </div>
            <div className="user-info-value">
              {user.username}
            </div>
          </div>
          <div className="user-info-item">
            <div className="user-info-label">
              Name:
            </div>
            <div className="user-info-value">
              {user.firstName} {user.lastName}
            </div>
          </div>
          <div className="user-info-item">
            <div className="user-info-label">
              Role:
            </div>
            <div className="user-info-value">
              {(userRole) ? profile.userRole.name : 'None'}
            </div>
          </div>
          <div className="user-info-item">
            <div className="user-info-label">
              Program Association:
            </div>
            <div className="user-info-value">
              {(program) ? profile.program.name : 'None'}
            </div>
          </div>
          <div className="user-info-item">
            <div className="user-info-label">
              Enabled:
            </div>
            <div className="user-info-value">
              <input type="checkbox" checked={user.enabled} disabled />
            </div>
          </div>
          <div className="user-info-item">
            <div className="user-info-label">
              Locked:
            </div>
            <div className="user-info-value">
              <input type="checkbox" checked={user.accountLocked} disabled />
            </div>
          </div>
          <div className="user-info-item">
            <div className="user-info-label">
              SuperUser:
            </div>
            <div className="user-info-value">
              <input type="checkbox" checked={superUser} disabled />
            </div>
          </div>
          <div className="user-info-item">
            <div className="user-info-label">
            </div>
            <div className="user-info-value">
              <SendPasswordLink userToSend={user} sendResetPasswordAction={sendResetPasswordAction}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
